// const baseURL = 'http://192.168.203.5:5192/api/v1/';
//const baseURLWithoutPort = 'https://new.iotfig.com/';



//test
const baseURL = 'http://new.iotfig.com/api/v1/';


// //local
// const baseURL = 'http://192.168.203.10:5129/api/v1/';


// //whs
// const baseURL = 'http://whs.behnoushiran.com:5129/api/v1/';



// const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BASE_URL : process.env.REACT_APP_DEV_API_URL;


export {baseURL}